import { Component, OnInit } from '@angular/core';
import { MediaService } from 'src/app/services/media.service';
import { VormingService } from 'src/app/services/vorming.service';

@Component({
  selector: 'app-vormingen',
  templateUrl: './vormingen.component.html',
  styleUrls: ['./vormingen.component.sass']
})
export class VormingenComponent implements OnInit {

  vormingen:any = [];

  constructor(private vormingService:VormingService) { }

  ngOnInit(): void {
    this.vormingService.getVormingen().subscribe(data => {
      for(let v of data.data) {
        v = this.vormingService.populateVorming(v);
        this.vormingen.push(v);
      }
    });
  }

}
